import { HStack } from '@ui-furniture/elements';

export const Row = HStack;
